function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useState } from 'react';
import { Form, Select } from 'antd';
import { useRequest } from '@umijs/hooks';
import client from '../../../feathers';
var {
  Option
} = Select;

function handleChange(value) {
  console.log("selected ".concat(value));
}

function getTags() {
  return _getTags.apply(this, arguments);
}

function _getTags() {
  _getTags = _asyncToGenerator(function* () {
    var query = {
      $limit: -1,
      $select: ['name'],
      $sort: {
        name: 1
      }
    };
    var params = {
      query
    };
    var tags = yield client.service('tags').find(params);
    return tags;
  });
  return _getTags.apply(this, arguments);
}

function Keywords() {
  var [children, setChildren] = useState([]);
  var {
    data,
    error,
    loading
  } = useRequest(() => getTags(), {
    // refreshDeps: [endpointId],
    onSuccess: (result, params) => {
      var options = result.map((tag, index) => {
        var {
          name
        } = tag;
        return /*#__PURE__*/React.createElement(Option, {
          key: index,
          value: name
        }, name);
      });
      setChildren(options);
    }
  });
  return /*#__PURE__*/React.createElement(Form.Item, {
    name: "keywords",
    label: "Keywords"
  }, /*#__PURE__*/React.createElement(Select, {
    mode: "tags",
    placeholder: "Select tags...",
    onChange: handleChange,
    showSearch: true,
    tokenSeparators: [',']
  }, children));
}

export default Keywords;